import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { dataAPI } from '../services/api';
import './Transformations.css';

const HUBFIT_API_URL = process.env.REACT_APP_API_URL || 'https://apidashboard.teamgreekgods.ma/api';

const Transformations = () => {
  const [tab, setTab] = useState('trim');
  const [assistants, setAssistants] = useState([]);
  const [transformations, setTransformations] = useState({ trim: [], excep: [] });
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    assistant_id: '',
    category: 'trim',
    client_name: '',
    comment: '',
    reason: ''
  });

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const [empRes, trRes] = await Promise.all([
        axios.get(`${HUBFIT_API_URL}/employees`, {
          headers: { Authorization: `Bearer ${process.env.REACT_APP_TOKEN}` }
        }),
        dataAPI.getTransformations()
      ]);

      if (empRes.data.success) {
        const employees = empRes.data.data || [];
        const formattedAssistants = employees.map((emp) => ({
          id: emp.id,
          store_id: emp.store_ids?.[0]?.id || emp.store_id,
          name: `${emp.first_name} ${emp.last_name}`,
          store: emp.store_ids?.[0]?.name || `WA ${emp.store_ids?.[0]?.code || emp.store_id}`,
          is_active: emp.is_active === 1
        }));
        setAssistants(formattedAssistants);
      }

      if (trRes.data.success) {
        const trData = trRes.data.data || [];
        const trim = trData.filter((t) => t.category === 'trim');
        const excep = trData.filter((t) => t.category === 'excep' || t.category === 'exceptionnel');
        setTransformations({ trim, excep });
      }
    } catch (error) {
      console.error('Failed to load data', error);
    }
  };

  const openModal = () => {
    setFormData({
      assistant_id: assistants[0]?.store_id || assistants[0]?.id || '',
      category: tab,
      client_name: '',
      comment: '',
      reason: ''
    });
    setShowModal(true);
  };

  const handleSave = async () => {
    try {
      const response = await dataAPI.createTransformation({
        assistant_id: parseInt(formData.assistant_id),
        category: formData.category,
        client_name: formData.client_name,
        comment: formData.comment,
        reason: formData.reason || ''
      });
      if (response.data.success) {
        setShowModal(false);
        loadData();
      }
    } catch (error) {
      console.error('Failed to save', error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await dataAPI.deleteTransformation(id);
      const updated = transformations[tab].filter((t) => t.id !== id);
      setTransformations({ ...transformations, [tab]: updated });
    } catch (error) {
      console.error('Failed to delete', error);
    }
  };

  const currentItems = transformations[tab] || [];
  const totalClients = currentItems.reduce((acc, t) => acc + 1, 0);

  return (
    <div className="transformations-page">
      <div className="section-header">
        <div className="section-dot"></div>
        <h2>Transformations clients</h2>
        <span className="count-badge">{totalClients} clients</span>
        <div className="tab-buttons">
          <button className={`tab-btn ${tab === 'trim' ? 'active' : ''}`} onClick={() => setTab('trim')}>Trimestriel</button>
          <button className={`tab-btn ${tab === 'excep' ? 'active' : ''}`} onClick={() => setTab('excep')}>Exceptionnel</button>
        </div>
      </div>

      <div className="desc-box">
        {tab === 'trim'
          ? 'Check-up trimestriel - suivi regulier des clients'
          : 'Check exceptionnel - suite a un evenement (blessure, voyage, etc.)'}
      </div>

      <button className="add-tr-btn-top" onClick={openModal}>+ Ajouter</button>

      <div className="tr-grid">
        {assistants.filter((a) => a.is_active).map((assistant) => {
          const assistantItems = currentItems.filter((t) => t.assistant_id === assistant.store_id);
          return (
            <div key={assistant.id} className="tr-card">
              <div className="tr-card-header">
                <div className="tr-card-info">
                  <span className="tr-assistant-name">{assistant.name}</span>
                  <span className="tr-assistant-store">{assistant.store}</span>
                </div>
              </div>
              <div className="tr-clients">
                {assistantItems.length === 0 ? (
                  <div className="no-clients">Aucun client</div>
                ) : (
                  assistantItems.map((item) => (
                    <div key={item.id} className="tr-client-item">
                      <div className="tr-client-name">{item.client_name}</div>
                      {item.comment && <div className="tr-client-comment">{item.comment}</div>}
                      {item.reason && <div className="tr-client-reason">{item.reason}</div>}
                      <button className="tr-delete-btn" onClick={() => handleDelete(item.id)}>×</button>
                    </div>
                  ))
                )}
              </div>
            </div>
          );
        })}
      </div>

      <button className="add-tr-btn" onClick={openModal}>+ Ajouter</button>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <h3>Ajouter un client transformation</h3>
            <div className="form-group">
              <label>Assistante</label>
              <select value={formData.assistant_id} onChange={(e) => setFormData({ ...formData, assistant_id: parseInt(e.target.value) })}>
                {assistants.map((a) => <option key={a.id} value={a.store_id}>{a.name} - {a.store}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label>Categorie</label>
              <select value={formData.category} onChange={(e) => setFormData({ ...formData, category: e.target.value })}>
                <option value="trim">Check trimestriel</option>
                <option value="excep">Check exceptionnel</option>
              </select>
            </div>
            {formData.category === 'excep' && (
              <div className="form-group">
                <label>Raison (obligatoire)</label>
                <input type="text" value={formData.reason} onChange={(e) => setFormData({ ...formData, reason: e.target.value })} placeholder="Ex: blessure, voyage..." />
              </div>
            )}
            <div className="form-group">
              <label>Nom du client</label>
              <input type="text" value={formData.client_name} onChange={(e) => setFormData({ ...formData, client_name: e.target.value })} placeholder="Ex: Amine B." />
            </div>
            <div className="form-group">
              <label>Commentaire</label>
              <textarea value={formData.comment} onChange={(e) => setFormData({ ...formData, comment: e.target.value })} rows="2" placeholder="Ex: -12kg en 3 mois" />
            </div>
            <div className="modal-actions">
              <button className="btn-primary" onClick={handleSave}>Enregistrer</button>
              <button className="btn-secondary" onClick={() => setShowModal(false)}>Annuler</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Transformations;
